import axios from 'axios'
const token = JSON.parse(localStorage.getItem('Usuario'))?.token

const clienteAxios = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_API}`,
  headers: {
    authorization: token
  }
})

export default clienteAxios